import { render, staticRenderFns } from "./VoiceCommand.vue?vue&type=template&id=2fd5aaf0&scoped=true"
import script from "./VoiceCommand.vue?vue&type=script&lang=js"
export * from "./VoiceCommand.vue?vue&type=script&lang=js"
import style0 from "./VoiceCommand.vue?vue&type=style&index=0&id=2fd5aaf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../deps/0/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd5aaf0",
  null
  
)

export default component.exports